// What initial.js does with the /extensions answer before the app loads. The app bundle only loads
// on a 200, so anything that isn't a 200 or a 401 has to show something or the page stays blank.
export const extensionsOutcome = (status) => {
    if (status === 200) return "load";
    if (status === 401) return "signin";
    return "fail";
};

// Starts sign-in and hands any failure to onFailure. signinRedirect() fetches the STS metadata
// first, so a blocked or down STS rejects here and would otherwise leave a blank page.
export const startSignIn = (userManager, onFailure) =>
    Promise.resolve()
        .then(() => userManager.signinRedirect())
        .catch(onFailure);

// Replaces the page with a message and a link back to it. textContent and href, never innerHTML:
// retryUrl is the page's own URL, which an attacker can put anything in. initial.js runs in <head>,
// so a failure can arrive before <body> exists; wait for it then.
export const showFailure = (doc, message, retryUrl) => {
    if (!doc.body) {
        doc.addEventListener("DOMContentLoaded", () => showFailure(doc, message, retryUrl), { once: true });
        return;
    }
    const text = doc.createElement("p");
    text.textContent = message + " ";
    const link = doc.createElement("a");
    link.href = retryUrl;
    link.textContent = "Try again";
    text.appendChild(link);
    doc.body.replaceChildren(text);
};

// The access_token cookie the server's /files/* image proxy reads. Pinned to / because without a
// path the browser scopes it to whatever route the tab is on when the token renews, which leaves
// the proxy holding a stale token.
export const accessTokenCookie = (token) => `access_token=${token}; path=/; secure`;
